export default (inventories, currency) => {
    const inventoriesFiltered = inventories.filter(({ isVip }) => !isVip);
    return inventoriesFiltered
        .filter((item) => item.level !== 1 && item.level !== 3)
        .map((inventory) => ({
        value: inventory,
        label: `${inventory.name} ${currency}${(inventory.priceCents.amount / 100).toFixed(2)}/yr`,
    }));
};
